import { useState, useEffect } from 'react';

const SCREEN_SIZES = {
  MOBILE: 425,
  TABLET: 768,
  SMALL_LAPTOP: 1024,
  LAPTOP: 1440,
};

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    isMobile: false,
    isTablet: false,
    isSmallLaptop: false,
    isLaptop: false,
    isLargeLaptop: false,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        isMobile: width <= SCREEN_SIZES.MOBILE,
        isTablet: width > SCREEN_SIZES.MOBILE && width <= SCREEN_SIZES.TABLET,
        isSmallLaptop: width > SCREEN_SIZES.TABLET && width <= SCREEN_SIZES.SMALL_LAPTOP,
        isLaptop: width > SCREEN_SIZES.SMALL_LAPTOP && width <= SCREEN_SIZES.LAPTOP,
        isLargeLaptop: width > SCREEN_SIZES.LAPTOP,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
}; 